<template>
  <el-dialog title="历史调价记录" :visible.sync="_dialogVisible" :before-close="handleClose">
    <el-form>
      <el-form-item label="商品信息">
        <el-table :data="goodsData" border>
          <el-table-column prop="goodCategoryName" align="center" label="分类名称" />
          <el-table-column prop="picture" align="center" label="图片">
            <template slot-scope="scope">
              <div class="wrap-picture-style">
                <img :src="scope.row.picture" style="width: 120px; height: 120px" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" align="center" label="菜品名称"> </el-table-column>
          <el-table-column prop="goodSpecName" align="center" label="规格(g)" />
          <el-table-column prop="pieceUnit" align="center" label="计价方式">
            <template slot-scope="scope">
              <span v-if="scope.row.pieceUnit === 0">计重</span>
              <span v-if="scope.row.pieceUnit === 1">计件</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="调价历史记录">
        <hx-table-result :page-info="pager" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
          <el-table ref="table" slot="content" :data="tableData" max-height="800" border>
            <el-table-column align="center" width="60" label="序号">
              <template slot-scope="scope">
                <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" align="center" label="调价时间">
              <template slot-scope="{ row }">
                {{ row.createDate | formatDate(true) }}
              </template>
            </el-table-column>
            <el-table-column prop="operator" align="center" label="操作者" />
            <el-table-column prop="beforeData" align="center" label="调价前单价">
              <template slot-scope="{ row }">
                <p>商品价格：{{ row.beforeData.price }}</p>
                <!-- <p v-for="i in row.beforeData.goodLevelPrices">
                  {{ i.levelName }} : {{ i.levelPrice }} 元
                </p> -->
              </template>
            </el-table-column>
            <el-table-column prop="afterPrice" align="center" label="调价后单价">
              <template slot-scope="{ row }">
                <p>商品价格：{{ row.afterData.price }}</p>
                <!-- <p v-for="i in row.afterData.goodLevelPrices">
                  {{ i.levelName }} : {{ i.levelPrice }} 元
                </p> -->
              </template>
            </el-table-column>
          </el-table>
        </hx-table-result>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      goodsData: []
    };
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", false);
      }
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.loadData();
          this.loadGoods();
        }
      }
    }
  },
  methods: {
    loadGoods() {
      this.$http({
        url: global.apiUrl + "/good/gooddetail?id=" + this.id,
        method: "GET"
      })
        .then((res) => {
          this.formLoading = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data;
              this.goodsData = [{ ...data }];
            } else {

            }
          }
        })
        .catch((err) => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 关闭弹窗
     * @params *
     */
    handleClose() {
      this._dialogVisible = false;
    },
    /**
     * 加载数据
     */
    loadData() {
      const params = Object.assign(this.pager, { id: this.id });
      this.$http({
        url: global.apiUrl + "/good/getUpdateRecord",
        method: "GET",
        params
      })
        .then((res) => {
          this.tableData = res.body.data.content;
          this.pager.total = res.body.data.totalElements;
          console.log(this.pager);
        })
        .catch((err) => {

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageIndex = 1;
      this.pager.pageSize = val;
      this.loadData();
    }
  }
};
</script>
